import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "base_screen_header"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1);

const _hoisted_3 = {
  class: "base_main_margin_top"
};
import CategoryManager from '@com/CategoryManager.vue';
import StatusBar from '@com/StatusBar.vue';
import ExamineTable from '@com/examine/ExamineTable.vue';
import { Search } from '@element-plus/icons-vue';
import useRoute from "@util/router";
import { ref, reactive } from 'vue';
import { $msg, $box } from "@ui/msg";
import api from "@api/examine";
export default {
  __name: 'TravelExamine',

  setup(__props) {
    const config = {
      type: 'travel'
    };
    const route = useRoute();
    const data = ref([]);
    const total = ref(0);
    route.watchRouter('travelexamine', () => {
      getStatistics();
      getList();
    });
    const baseOptions = ref([]);
    getConfig();

    function getConfig() {
      api.base(val => {
        baseOptions.value = val;
      });
    }

    const statusList = reactive([{
      label: '全部',
      value: 'all',
      total: 0
    }, {
      label: '待审批',
      value: '1007002',
      total: 0
    }, {
      label: '已通过',
      value: '1007004',
      total: 0
    }, {
      label: '已驳回',
      value: '1007003',
      total: 0
    }]);
    const base = ref(route.query().base || '');
    const name = ref(route.query().name || '');

    function searchBase(val) {
      route.replaceQuery('base', val);
    }

    function searchName(val) {
      route.replaceQuery('name', val);
    }

    getList();

    function getList() {
      let routeQuery = route.query();
      api.list(config.type, {
        classify: routeQuery.c,
        name: routeQuery.name,
        flowStatus: routeQuery.status,
        shopCode: routeQuery.base,
        page: routeQuery.p,
        size: routeQuery.s
      }, val => {
        total.value = val.total;
        data.value = val.list.map(e => {
          // 1007001草稿 1007002待审批 1007003被驳回 1007004审批通过
          switch (e.flowStatus) {
            case "1007001":
              e.state = "草稿";
              break;

            case "1007002":
              e.state = "待审批";
              break;

            case "1007003":
              e.state = "已驳回";
              break;

            case "1007004":
              e.state = "已通过";
              break;
          }

          return e;
        });
      });
    }

    getStatistics();

    function getStatistics() {
      let routeQuery = route.query();
      api.num(config.type, routeQuery.c, routeQuery.base, routeQuery.name, val => {
        statusData(val);
      });
    }

    function statusData(val) {
      statusList.forEach((e, i) => {
        e.total = val[i];
      });
    }

    return (_ctx, _cache) => {
      const _component_el_aside = _resolveComponent("el-aside");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createBlock(_component_el_container, null, {
        default: _withCtx(() => [_createVNode(_component_el_aside, {
          width: "170px"
        }, {
          default: _withCtx(() => [_createVNode(CategoryManager, {
            config: config
          })]),
          _: 1
        }), _createVNode(_component_el_main, {
          class: "base_main_content"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
            inline: true,
            class: "base_search_form",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: base.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => base.value = $event),
                onChange: searchBase,
                placeholder: "请选择基地",
                clearable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseOptions.value, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: name.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => name.value = $event),
                "onKeyup[native]": searchName,
                onChange: searchName,
                placeholder: "产品名称",
                clearable: "",
                "suffix-icon": _unref(Search)
              }, null, 8, ["modelValue", "suffix-icon"])]),
              _: 1
            })]),
            _: 1
          })]), _createVNode(StatusBar, {
            data: statusList,
            default: "all"
          }, null, 8, ["data"]), _createElementVNode("div", _hoisted_3, [_createVNode(ExamineTable, {
            type: config.type,
            data: data.value,
            total: total.value,
            onGetData: getList
          }, null, 8, ["type", "data", "total"])])]),
          _: 1
        })]),
        _: 1
      });
    };
  }

};